import Icon from "@ant-design/icons";
import {Image} from "antd";
import {
    SKSIconImg
} from "../../../../assets";


export const MyIcon = (props) => <Image src={SKSIconImg} preview={false}/>
